import { createContext, useContext, useState, type ReactNode } from 'react';

interface SearchValue {
  /** The current dish-search query (driven by the top-bar search box). */
  query: string;
  setQuery: (q: string) => void;
}

const SearchContext = createContext<SearchValue | null>(null);

/** App-wide dish search — the top-bar search box writes it, the menu/home read it. */
export function SearchProvider({ children }: { children: ReactNode }) {
  const [query, setQuery] = useState('');
  return <SearchContext.Provider value={{ query, setQuery }}>{children}</SearchContext.Provider>;
}

/** Read/write the shared search query. Safe no-op outside a provider. */
export function useSearch(): SearchValue {
  return useContext(SearchContext) ?? { query: '', setQuery: () => {} };
}
